import styled, { css } from "styled-components";

export const PopupBackground = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: rgba(36, 33, 33, 0.863);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
`;

export const PopupContainer = styled.div`
  width: 500px;
  height: auto;
  border-radius: 12px;
  background-color: white;
  display: flex;
  flex-direction: column;
  padding: 25px;
`;

export const TitleCloseBtn = styled.div`
  display: flex;
  justify-content: flex-end;

  button {
    background-color: transparent;
    border: none;
    font-size: 25px;
    cursor: pointer;
  }
`;

export const UserTitle = styled.div`
  display: inline-block;
  text-align: center;
  margin-top: 10px;

  img {
    height: 8rem;
  }
`;

export const BodyTitle = styled.div`
  flex: 50%;
  margin-top: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.7rem;
  text-align: center;

  p {
    color: #747576;
    font-weight: 500;
  }
`;

export const BodyUser = styled.div`
  font-weight: 500;
  font-size: 1.9rem;
  font-family: Roboto !important;
  text-align: center;
  margin: 30px 0 30px;
  display: flex;
  justify-content: center;

  label {
    border-bottom: 2px solid #00a2e0;
    color: #414244;
    width: 70%;
  }
`;

export const FooterUser = styled.div`
  flex: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
